import { Card, CardContent, CardDescription, CardHeader, CardTitle, Switch } from '@hub-la/shadcn'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const TogglePostComment = ({
  onChange,
  isLoading,
  defaultValue,
}: {
  onChange?: (checked: boolean) => void
  isLoading?: boolean
  defaultValue?: boolean
}) => {
  const [showPostCommentTitle, setShowPostCommentTitle] = useState<boolean | undefined>()
  const { t } = useTranslation()

  const handleToggle = useCallback(
    (checked: boolean) => {
      setShowPostCommentTitle(checked)
      if (onChange) {
        onChange(checked)
      }
    },
    [setShowPostCommentTitle, onChange],
  )

  useEffect(() => {
    if (!defaultValue) return
    setShowPostCommentTitle(defaultValue)
  }, [defaultValue])

  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle>{t('member-area.settings.togglePostComment.title')}</CardTitle>
        <CardDescription>{t('member-area.settings.togglePostComment.description')}</CardDescription>
      </CardHeader>

      <CardContent className="flex flex-col gap-4 p-6">
        <div className="flex items-center space-x-2">
          <Switch
            id="post-comment"
            checked={showPostCommentTitle}
            onCheckedChange={handleToggle}
            disabled={isLoading}
            data-testid="switch-postComment"
          />

          <label
            htmlFor="post-comment"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            {t('member-area.settings.togglePostComment.options.postComment.label')}
          </label>
        </div>

        <p className="text-sm text-muted-foreground mt-3 mb-3">
          {t('member-area.settings.togglePostComment.options.postComment.description')}
        </p>
      </CardContent>
    </Card>
  )
}

export default TogglePostComment
